var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"main":_vm.$t('cadastro-de-produtos'),"sub":"","imagem":"dashboard.png"}}),_c('GridProducts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }